module.exports = __webpack_public_path__ + "static/media/3DPPA29.13a62200.jpg";